import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function FailedAttempts() {
  const attempts = ['Intentaste corregir por fuera lo que está roto por dentro (la atmósfera del hogar).', 'Oraste por la familia, pero no ejerciste la autoridad sacerdotal para ungir y sellar tu territorio.', 'Permitiste que palabras de queja y objetos sin bendición contaminaran el santuario que es tu casa.', 'Buscaste consejos humanos, olvidando que la verdadera paz es un fruto del Espíritu que se cultiva con orden bíblico.'];
  return <section className="py-20 px-6 bg-cream-100" data-id="element-15">
      <div className="max-w-3xl mx-auto" data-id="element-16">
        <FadeIn data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-brown-900" data-id="element-18">
            Por qué lo que has intentado no ha funcionado
          </h2>

          <div className="space-y-6" data-id="element-19">
            {attempts.map((attempt, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-20">
                <div className="flex items-start gap-4 bg-white p-6 rounded-lg shadow-sm border border-cream-200" data-id="element-21">
                  <XCircle className="w-6 h-6 text-gold-500 flex-shrink-0 mt-1" data-id="element-22" />
                  <p className="text-lg text-brown-800 leading-relaxed" data-id="element-23">
                    {attempt}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}